import React from 'react';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { useClienteAuth } from '../context/ClienteAuthContext';

const ClienteConfiguracion = () => {
    const { cliente } = useClienteAuth();

    return (
        <div className="ec-container" style={{ padding: '2rem 0' }}>
            <h2 style={{ marginBottom: 16 }}>Configuración</h2>
            {!cliente ? (
                <Message severity="warn" text="Inicia sesión para acceder a configuración." style={{ width: '100%' }} />
            ) : (
                <Card>
                    <p style={{ margin: 0 }}>
                        Próximamente podrás configurar direcciones, notificaciones y preferencias.
                    </p>
                </Card>
            )}
        </div>
    );
};

export default ClienteConfiguracion;
